export default __webpack_public_path__ + "static/media/a037-7.8c7b3a2f.svg";